import { useMemo } from "react";
import { ChangeRequestModalTypes } from "@enums/change-request-modal-types";
import { ChangeRequestModal } from "../change-request-modal/change-request-modal";
import { IdentityProviderChangeRequestResponse } from "@idw-types/data/identity-providers";

type ApproveIdentityProviderChangeRequestModalProps = {
    onModalClose: () => void;
    onSubmitHandler: (onModalClose: () => void) => Promise<IdentityProviderChangeRequestResponse>;
};

export const ApproveIdentityProviderChangeRequestModal = (props: ApproveIdentityProviderChangeRequestModalProps) => {
    const { onModalClose, onSubmitHandler } = props;

    const bodyElement = useMemo(() => {
        return (
            <div>
                <p>Are you sure you would like to approve this Change Request?</p>
            </div>
        );
    }, []);

    const onSubmit = async () => {
        return await onSubmitHandler(onModalClose);
    };

    return (
        <ChangeRequestModal
            changeRequestModalType={ChangeRequestModalTypes.APPROVE}
            title={"Confirm your Approval"}
            body={bodyElement}
            buttonText={"Confirm"}
            onModalClose={onModalClose}
            onSubmit={onSubmit}
        />
    );
};